import AnimatedPressable from "./animated-pressable";
import * as React from "react";
import type { DripsyColor } from "@utils";
import { useDripsyColor } from "@utils";

type HitslopFull = { bottom: number; right: number; left: number; top: number };

interface IconButtonTypes {
  children: any;
  onPress?: (e?: any) => void;
  hitslop?: HitslopFull | number;
  backgroundColor?: DripsyColor;
}

function IconButton({ children, onPress, hitslop = 0, backgroundColor, ...rest }: IconButtonTypes) {
  const secondaryBackgroundPressed = useDripsyColor({ color: "$secondaryBackgroundPressed" });
  return (
    <AnimatedPressable
      {...rest}
      hitSlop={hitslop as any}
      onPress={onPress}
      animate={React.useMemo(
        () =>
          ({ hovered, pressed }) => {

            return {
              backgroundColor: hovered || pressed ? secondaryBackgroundPressed : backgroundColor || "#ffffff",
            };
          },
        [backgroundColor]
      )}
      style={{ alignItems: "center", padding: 8, borderRadius: 100 }}
    >
      {children}
    </AnimatedPressable>
  );
}

export default IconButton;
